import { apiGet } from '../utils/axios';

const base_url = `/content`;

export const getPrograms = () => {
  return apiGet(`${base_url}/programs`);
};

export const getProgram = (id) => {
  return apiGet(`${base_url}/programs/${id}`);
};

export const getCurriculum = (id) => {
  return apiGet(`${base_url}/curriculums/${id}`);
};

export const getProgramCurriculums = (id) => {
  return apiGet(`${base_url}/programs/${id}/curriculums`);
};

export const getCourses = () => {
  return apiGet(`${base_url}/courses`);
};

export const getCurriculumCourses = (id) => {
  return apiGet(`${base_url}/curriculums/${id}/courses`);
};

export const getCourse = (id) => {
  return apiGet(`${base_url}/courses/${id}`);
};
